import type {ThreadRecord} from '@reados/contracts';

export interface ConversationModelSelection {model:string;effort:string}
export function readModelSelection(value:unknown):ConversationModelSelection|null {
 if(!value||typeof value!=='object')return null;
 const selection=value as Record<string,unknown>;
 return typeof selection.model==='string'&&selection.model&&typeof selection.effort==='string'?{model:selection.model,effort:selection.effort}:null;
}

/** A fork inherits its authoritative model. Until the user makes a choice in
 * this conversation, omit effort so the native inherited setting survives. */
export function conversationModelSelection(thread:ThreadRecord|null,choice:ConversationModelSelection|null,global:ConversationModelSelection):ConversationModelSelection {
 return thread?.forkedFromThreadId?choice??{model:thread.model??'',effort:''}:global;
}
